import { ColumnWidthOutlined } from '@ant-design/icons';
import { Space, Switch, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { EnumContentSize } from './useLocalTableContentSize.ts';

const SwitchStyledDiv = styled.div``;
const SwitchTextLabel = styled.div`
  /* font-size: 0.85em;
  font-weight: 300; */
`;

export interface ISwitchContenSizeButtonProps {
  currentContentSize: EnumContentSize | null;
  onChangeSize?: (size: EnumContentSize) => void;
}

/**
 * Button con icona animata
 * Utilizzato per oprire il pannello con il form di ricerca (Collapse)
 */
export function SwitchContenSizeButton(props: ISwitchContenSizeButtonProps) {
  const { currentContentSize, onChangeSize } = props;

  const { t } = useTranslation();

  const onChange = (checked: boolean) => {
    onChangeSize?.(
      checked ? EnumContentSize.FULL_WIDTH : EnumContentSize.BOXED,
    );
  };

  return (
    <SwitchStyledDiv {...props}>
      <Tooltip
        title={t(
          'column-picker.config-drawer-tooltip',
          'Cambia larghezza tabella',
        )}
        placement="bottomLeft"
      >
        <Space>
          <SwitchTextLabel>
            <ColumnWidthOutlined />
          </SwitchTextLabel>

          <Switch
            checkedChildren={t('column-picker.full-switch-text', 'FULL')}
            unCheckedChildren={t('column-picker.boxed-switch-text', 'BOXED')}
            checked={currentContentSize == EnumContentSize.FULL_WIDTH}
            onChange={onChange}
          />
        </Space>
      </Tooltip>
    </SwitchStyledDiv>
  );
}
